export enum Permission {
  ItemPriceManagementView = 'item_price_management.view',
  ItemPriceManagementModify = 'item_price_management.modify',
  ItemPriceManagementDeleteChangeRequest = 'item_price_management.delete_change_request',
  ItemPriceManagementReview = 'item_price_management.review',
  ItemPriceManagementDebug = 'item_price_management.debug',
}
